import { Transform, Type } from 'class-transformer';
import { ApplicationDate } from '../../shared/utils/formatted-date';

export abstract class BaseEntity {
  id!: number;

  @Type(() => ApplicationDate)
  @Transform(({ value }) => new ApplicationDate(value))
  createdAt!: ApplicationDate;

  @Type(() => ApplicationDate)
  @Transform(({ value }) => new ApplicationDate(value))
  updatedAt!: ApplicationDate;
}
